// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"93fa4013","129":"b88e13b9","872":"ed4161e9","904":"5b1d09f4"}[chunkId] + ".chunk.css";
};